import React, { useState } from 'react';
import './EditorAccordion.css';

interface EditorAccordionProps {
    selectedFont: string;
    handleFontChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    fontsList: string[];
    headerColor: string;
    handleHeaderColorChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    servicesColor: string;
    handleServicesColorChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    footerColor: string;
    handleFooterColorChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const EditorAccordion: React.FC<EditorAccordionProps> = ({
    selectedFont,
    handleFontChange,
    fontsList,
    headerColor,
    handleHeaderColorChange,
    servicesColor,
    handleServicesColorChange,
    footerColor,
    handleFooterColorChange
}) => {
    const [activeSection, setActiveSection] = useState<string | null>(null);

    const toggleSection = (section: string) => {
        setActiveSection(activeSection === section ? null : section);
    };

    return (
        <div className="editor-accordion">
            {/* Sección de Tipografía */}
            <div className="accordion-item">
                <h3 onClick={() => toggleSection('font')}>Cambiar Tipografía</h3>
                {activeSection === 'font' && (
                    <div className="accordion-content">
                        <select value={selectedFont} onChange={handleFontChange}>
                            {fontsList.map((font) => (
                                <option
                                    key={font}
                                    value={font}
                                    style={{ fontFamily: font }}
                                >
                                    {font}
                                </option>
                            ))}
                        </select>
                    </div>
                )}
            </div>

            <div className="accordion-item">
                <h3 onClick={() => toggleSection('colors')}>Cambiar Colores</h3>
                {activeSection === 'colors' && (
                    <div className="accordion-content">
                        <h4>Cambiar Color del Header</h4>
                        <input
                            type="color"
                            value={headerColor}
                            onChange={handleHeaderColorChange}
                        />
                        <h4>Cambiar Color de la Sección de Servicios</h4>
                        <input
                            type="color"
                            value={servicesColor}
                            onChange={handleServicesColorChange}
                        />
                        <h4>Cambiar Color del Footer</h4>
                        <input
                            type="color"
                            value={footerColor}
                            onChange={handleFooterColorChange}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default EditorAccordion;
